import t from"react";export const CheckboxContext=t.createContext(null);export const useCheckbox=()=>t.useContext(CheckboxContext);